var map = {
	"./19A8D0@2x.png": "c485",
	"./584831Fecef1014C0B5E4Aa7@2x.png": "e1c3",
	"./barclays@2x.png": "aa04",
	"./ct-box.png": "cc05",
	"./en-box.png": "82b5",
	"./goldmanSachsLogo@2x.png": "4d15",
	"./group6@2x.png": "0deb",
	"./invalidName@2x.png": "1cbf",
	"./ja-box.png": "a78b",
	"./jpmorgan@2x.png": "c819",
	"./ko-box.png": "cfa3",
	"./nomuraHoldingsLogo@2x.png": "d38c",
	"./possibility@2x.png": "c4eb",
	"./screen-bottom.png": "216d",
	"./screen-top.png": "6779",
	"./service-01.png": "498a",
	"./service-bg-m.png": "aa97",
	"./service-bg.png": "8290",
	"./service-partner.png": "ea2a",
	"./th-box.png": "1c4b",
	"./ubsLogoLogotypeEmblem@2x.png": "a420",
	"./vi-box.png": "6486",
	"./zh-box.png": "6136"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e836";